<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader title="HCP Certification View"></PageHeader>
      <div class="filter-wrapper">
        <el-form>
          <el-form-item label-width="40px" label="Role" prop="role" v-role="[1]">
            <el-select v-model="form.role" placeholder="Please select Role" filterable @change="roleChange">
              <el-option v-for="(item, idx) in roleOptions" :key="idx" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="65px" label="Leader" prop="taId" v-role="[1]">
            <el-select v-model="form.taId" placeholder="Please select Leader" filterable @change="taChange">
              <el-option v-for="(item, idx) in taOptions" :key="idx" :label="item.TAName" :value="item.TAID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Team" label-width="55px">
            <el-select v-model="form.teamId" placeholder="Please select Team" @change="teamChange" filterable>
              <el-option v-for="(item, idx) in teamOptions" :key="idx" :label="item.TeamName" :value="item.TeamID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="User" label-width="50px">
            <el-select v-model="form.mlId" placeholder="Please select User" filterable>
              <el-option v-for="(item, idx) in mlListOptions" :key="idx" :label="item.MLName" :value="item.MLID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="query-action">
          <el-button type="primary" icon="el-icon-search" @click="getTableData()" :disabled="queryable">
            Query
          </el-button>
          <el-button type="primary" icon="iconfont icon-export" @click="getTableData(true)" :disabled="exportable"
            :loading="exporting">
            Export
          </el-button>
        </div>
      </div>
    </div>
    <div class="charts" ref="charts" v-role="[2]">
      <div v-show="!chartDataEmpty" class="chart" ref="chart"></div>
      <div class="empty-placeholder" v-show="chartDataEmpty">
        <span class="empty-title">
          No. Of SE/CE / Wechat Account / Active / Accepted Terms
        </span>
        <div class="chart empty">
          <span>No Data</span>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading...">
        <el-table-column prop="TeamName" label="Team" min-width="90" />
        <el-table-column prop="MLName" label="User" min-width="90" />
        <el-table-column prop="TaConfigName" label="TA" min-width="130" />
        <el-table-column prop="SECount" label="No. Of HCP" min-width="90" />
        <el-table-column prop="AssociatedWechatAccounts" label="No. Of Wechat Accounts" min-width="200" />
        <el-table-column min-width="120" prop="Active" label="No. Of Active" />

        <el-table-column label="No. Of AcceptedTerms" min-width="200" prop="AcceptedTerms" />
        <!-- <el-table-column
          label="No. Of AcceptedTerms By User"
          min-width="250"
          prop="AcceptTermsByML"
        /> -->
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import * as echarts from "echarts/core";
import { ScatterChart } from "echarts/charts";
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
} from "echarts/components";
import { SVGRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
  ScatterChart,
  SVGRenderer,
]);
import downloadjs from "downloadjs";
import { getDataZoomOptions } from "../../utils/echarts";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "SE/CE-Certification-View",
  data() {
    return {
      tableLoading: false,
      exporting: false,
      tableData: [],
      form: {
        role: "",
        taId: "",
        teamId: "",
        mlId: "",
      },
      roleList: [],
      taList: [],
      teamList: [],
      mlList: [],
      queryable: true,
      exportable: true,
      // charts as follow:
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      chart: null,
      chartDataEmpty: true,
      resizeListener: null,
    };
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
      if (this.$options.name === this.$route.meta.title) {
        echarts.throttle(() => {
          this.renderCharts(true);
        }, 200);
      }
    });
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    isShowCharts() {
      return this.role === RoleCode.Supervisor;
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    mlName() {
      let ml = this.mlListOptions.find((item) => item.MLID === this.form.mlId);
      return ml ? ml.MLName : "";
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
        this.taList.filter(({ RoleName }) => {
          return this.form.role ? this.form.role === "MSL" ? RoleName === "TALead" : RoleName.indexOf(this.form.role) > -1 : true;
        })
      );
    },
    mlListOptions() {
      return this.mlList.filter((i) => {
        return (
          (this.form.teamId != ""
            ? i.TeamID === this.form.teamId
            : this.teamOptions.some((j) => j.TeamID === i.TeamID)) ||
          i.MLName === "All"
        );
      });
    },
    teamOptions() {
      let options = this.teamList.filter(({ TAID, RoleName }) => {
        return this.form.taId ? this.form.taId === TAID
          : (RoleName.indexOf(this.form.role) > -1 || (this.form.role === "MSL" && (RoleName === "TALead" || RoleName === "Supervisor")))
      });
      return this.role === RoleCode.Admin || this.role === RoleCode.TALead ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options) : options;
    },
    clientWidth() {
      return document.body.clientWidth;
    },
  },
  mounted() {
    if (this.isShowCharts) {
      this.renderCharts();
      this.resizeListener = echarts.throttle(() => {
        if (this.$options.name === this.$route.meta.title) {
          this.onResize();
          this.$nextTick(() => {
            this.renderCharts(true);
          });
        }
      }, 100);
      addResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  beforeDestroy() {
    if (this.isShowCharts && this.resizeListener) {
      removeResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  activated() {
    this.onResize();
    this.$nextTick(() => {
      this.renderCharts(true);
    });
  },
  methods: {
    getDataZoomOptions,
    onResize() {
      if (this.$route.meta.title === this.$options.name) {
        this.chart && this.chart.resize();
      }
    },
    hideLoadings() {
      this.chart && this.chart.hideLoading();
    },
    showLoadings() {
      this.chart && this.chart.showLoading(this.loadingOption);
    },
    renderCharts(hideLoading = false) {
      this.renderChart();
      if (hideLoading) {
        this.hideLoadings();
      }
    },
    renderChart() {
      let chart = this.$refs.chart;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let seData = [];
      let wechatAccountData = [];
      let activeData = [];
      let acceptedTermsData = [];
      this.tableData.forEach((item) => {
        xAxisData.push(item.MLName);
        seData.push({ name: item.MLName, value: item.SECount });
        wechatAccountData.push({
          name: item.MLName,
          value: item.AssociatedWechatAccounts,
        });
        activeData.push({ name: item.MLName, value: item.Active });
        acceptedTermsData.push({
          name: item.MLName,
          value: item.AcceptedTerms,
        });
      });
      this.chartDataEmpty = this.tableData.length === 0;
      const itemStyle = {
        opacity: 0.8,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "rgba(0,0,0,0.1)",
      };
      let option = {
        title: {
          text: "No. Of SE/CE / Wechat Accounts / Active / Accepted Terms",
          left: "center",
          textStyle: {
            color: "#000000",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "axis",
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter(params) {
            let htmlDom =
              params[0].name != " " ? `<h4>${params[0].name}</h4>` : "";
            let isEmpty = false;
            params.forEach((item) => {
              isEmpty = item.value === "";
              if (!isEmpty) {
                htmlDom += `<div class="chart-tooltip"><i style="background:${item.color}"></i><span>${item.seriesName}</span><strong>${item.value}</strong></div>`;
              }
            });
            return htmlDom;
          },
        },
        legend: {
          top: "6%",
          data: [
            "No. Of SE/CE",
            "No. Of Wechat Accounts",
            "No. Of Active",
            "No. Of Accepted Terms",
          ],
        },
        grid: {
          left: "2%",
          right: "5%",
          top: "20%",
          bottom: 30,
          containLabel: true,
        },
        dataZoom: xAxisData.length > 25 ? this.getDataZoomOptions(0, 28) : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${(index + 1) % 2 !== 0 && xAxisData.length > 10 ? "\n" : ""
                }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          min: -1,
          max: xAxisData.length,
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "No. Of SE/CE",
            type: "scatter",
            itemStyle: itemStyle,
            data: seData,
          },
          {
            name: "No. Of Wechat Accounts",
            type: "scatter",
            itemStyle: itemStyle,
            data: wechatAccountData,
          },
          {
            name: "No. Of Active",
            type: "scatter",
            itemStyle: itemStyle,
            data: activeData,
          },
          {
            name: "No. Of Accepted Terms",
            type: "scatter",
            itemStyle: itemStyle,
            data: acceptedTermsData,
          },
        ],
      };
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart, null, {
          renderer: "svg",
        });
        this.chart.showLoading(this.loadingOption);
      }
      this.chart.setOption(option);
    },
    roleChange() {
      this.form.taId = "";
      this.taChange();
    },
    taChange() {
      this.form.teamId = "";
      this.form.mlId = "";
    },
    teamChange() {
      this.form.mlId = "";
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      if (this.isShowCharts && !exportable) {
        this.chartDataEmpty = false;
        this.$nextTick(() => {
          this.onResize();
        });
        this.showLoadings();
      }
      let params = {
        ...this.form,
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
          mlName: this.mlName,
        });
      }
      this.axios
        .get(`analytics/seCertification`, {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableData = data;
              this.tableLoading = false;
              this.renderCharts(true);
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get("analytics/mlList"),
        this.axios.get(`analytics/roleList`)
      ]).then((res) => {
        this.getTAList(res[0]);
        this.getTeamList(res[1]);
        this.getMlList(res[2]);
        this.getRoleList(res[3]);
        this.getTableData();
        this.queryable = false;
        this.exportable = false;
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (this.role === RoleCode.Supervisor || this.role === RoleCode.TALead) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(({ value }) => roleName.indexOf(value) > -1) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        if (this.role === RoleCode.TALead) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        } else {
          this.taList = data;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (this.role == RoleCode.Supervisor) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getMlList({ code, data, msg }) {
      if (200 === code) {
        this.mlList = [
          {
            MLName: "All",
            MLID: "",
            TeamID: "",
          },
        ].concat(data);
      } else {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.charts {
  padding-top: 15px;
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 15px;

  .chart {
    width: 100%;
    height: 400px;

    &.empty {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #909399;
    }
  }
}
</style>
